module.exports = __webpack_public_path__ + "static/media/badge_tiyu.d68d92e1.png";